import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import SSOAuthService from './SSOAuthService.ts';
import { Button, CircularProgress, Grid } from '@material-ui/core';
import useAuthContext from "../../hooks/useAuthContext.js";
import { useStyles } from "./SSOAuthCallback.styles.tsx";
import { useTheme } from "@material-ui/core";

const SSOAuthCallback: React.FC = () => {
  const theme = useTheme();
  const classes = useStyles();
  const [error, setError] = useState<string | null>(null);
  const history = useHistory();
  const { setUserSession, markAsUserHasLoggedIn, signInUserSSO } = useAuthContext();
  const logouturi = localStorage.getItem('logouturi')!;

  const handleCallback = async () => {
    // Get the authorization code from URL
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const authSvc = new SSOAuthService();

    if (!code) {
      setError('No authorization code found in the callback URL');
      return;
    } else {     
      try {
        // Exchange the authorization code for tokens
        const tokens = await authSvc.handleCallback(code);

        signInUserSSO(tokens);
        setUserSession(tokens, true);
        markAsUserHasLoggedIn();
      } catch (err) {
        console.error('Error during authentication callback:', err);
        setError('Authentication failed. Please try again.');
      }
    }
  };

  const redirectToLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = logouturi || window.location.origin;
  }

  useEffect(() => {
    handleCallback();
  }, [history]);

  if (error) {
    return (
      <div className={classes.error}>
        <h2>Authentication Error</h2>
        <p className={classes.errormessage}>{error}</p>
        <Grid container className={classes.loginbutton}>
          <Grid item>
              <Button
                data-id="login-button"
                variant="contained"
                color="primary"
                onClick={() => history.push('/login')}
              >
                Go to Login
              </Button>
          </Grid>
        </Grid>
        <Grid container className={classes.logoutmessage}>
        Having trouble logging in?
          <Button className={classes.logout} onClick={redirectToLogout}>
             Try logging out of all sessions
          </Button>
        </Grid>
      </div>
    );
  }

  return <CircularProgress size={35} />;
};

export default SSOAuthCallback;